import { BillableMaterial } from '../types';
import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutline, Settings } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import BillableMaterialItem from './BillableMaterialItem';

type BillableMaterialColumnProps = {
  isUserAdmin: boolean;
  materials: BillableMaterial[];
};

export default function BillableMaterialColumn({ isUserAdmin, materials }: BillableMaterialColumnProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleConfigureMaterials = () => {
    if (isUserAdmin) navigate('/billable-materials');
  };

  if (materials.length === 0) {
    return (
      <Stack direction='column' alignItems='center' justifyContent='center' gap='1em'>
        <CheckCircleOutline sx={{ color: 'text.secondary' }} />
        <Typography variant='body2' color='text.secondary' textAlign='center'>
          {t('billableMaterial.noConditionSetMatching')}
        </Typography>
        {isUserAdmin && (
          <Button onClick={handleConfigureMaterials} variant='text' startIcon={<Settings />}>
            {t('common.configure')}
          </Button>
        )}
      </Stack>
    );
  }

  return (
    <Stack flex={1} gap={1}>
      {materials.map((material) => (
        <BillableMaterialItem key={material.id} material={material} />
      ))}
    </Stack>
  );
}
